/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CouponGiftDTO
 */
export interface CouponGiftDTO {
    /**
     * 
     * @type {string}
     * @memberof CouponGiftDTO
     */
    'occasion': CouponGiftDTOOccasionEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponGiftDTO
     */
    'giftType': CouponGiftDTOGiftTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponGiftDTO
     */
    'status': CouponGiftDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponGiftDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CouponGiftDTO
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CouponGiftDTO
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CouponGiftDTO
     */
    'payoutDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponGiftDTO
     */
    'recurring'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponGiftDTO
     */
    'inviteWhenActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponGiftDTO
     */
    'sendMailWhenActive'?: boolean;
}

export const CouponGiftDTOOccasionEnum = {
    Birthday: 'BIRTHDAY',
    SaintsDay: 'SAINTS_DAY',
    ChildBirth: 'CHILD_BIRTH',
    ChildBaptism: 'CHILD_BAPTISM',
    ChildCommunion: 'CHILD_COMMUNION',
    ChildConfirmationCath: 'CHILD_CONFIRMATION_CATH',
    ChildConfirmationProt: 'CHILD_CONFIRMATION_PROT',
    Wedding: 'WEDDING',
    WeddingSilver: 'WEDDING_SILVER',
    WeddingGold: 'WEDDING_GOLD',
    PassedExam: 'PASSED_EXAM',
    CompanyAnniversary: 'COMPANY_ANNIVERSARY',
    Other: 'OTHER',
    Achievement: 'ACHIEVEMENT',
    WorkPerformance: 'WORK_PERFORMANCE',
    Commitment: 'COMMITMENT',
    Proposal: 'PROPOSAL',
    Recruitment: 'RECRUITMENT',
    Attendance: 'ATTENDANCE',
    SigningBonus: 'SIGNING_BONUS',
    ProfitSharing: 'PROFIT_SHARING'
} as const;

export type CouponGiftDTOOccasionEnum = typeof CouponGiftDTOOccasionEnum[keyof typeof CouponGiftDTOOccasionEnum];
export const CouponGiftDTOGiftTypeEnum = {
    Gift: 'GIFT',
    Incentive: 'INCENTIVE'
} as const;

export type CouponGiftDTOGiftTypeEnum = typeof CouponGiftDTOGiftTypeEnum[keyof typeof CouponGiftDTOGiftTypeEnum];
export const CouponGiftDTOStatusEnum = {
    Pending: 'PENDING',
    Available: 'AVAILABLE',
    Redeemed: 'REDEEMED',
    PaymentFailed: 'PAYMENT_FAILED'
} as const;

export type CouponGiftDTOStatusEnum = typeof CouponGiftDTOStatusEnum[keyof typeof CouponGiftDTOStatusEnum];


